import { ProductId } from '../schemas/products.schemas';
import anarchyCloudAllAccess from '../../../assets/images/thumbnails/anarchy-cloud-all-access.png';
import anarchyCloudOneApp from '../../../assets/images/thumbnails/anarchy-cloud-one-app.png';
import anarchyCompleteBundleAllPlugins from '../../../assets/images/thumbnails/anarchy-complete-bundle-all-plugins.png';
import effIt from '../../../assets/images/thumbnails/eff-it.png';
import beautyBoxCrossgrade from '../../../assets/images/thumbnails/beauty-box-crossgrade.png';
import beautyBoxPhotoUpgrade from '../../../assets/images/thumbnails/beauty-box-photo-upgrade.png';
import beautyBoxPhoto from '../../../assets/images/thumbnails/beauty-box-photo.png';
import beautyBoxUpgrade123 from '../../../assets/images/thumbnails/beauty-box-upgrade-123.jpg';
import beautyBoxUpgrade from '../../../assets/images/thumbnails/beauty-box-upgrade.jpg';

// import beautyBox from '../../../assets/images/thumbnails/beauty-box.jpg';
import beautyBox from '../../../assets/images/thumbnails/beauty-box.png';
import beautyExtreme from '../../../assets/images/thumbnails/beauty-extreme.png';
import beautyFlicker from '../../../assets/images/thumbnails/beauty-flicker.png';

import beautyBox6 from '../../../assets/images/thumbnails/bb6.jpg';
import beautyBoxUpgrade1to4 from '../../../assets/images/thumbnails/bb6-up1-4.png';
import beautyBoxUpgrade5to6 from '../../../assets/images/thumbnails/bb6-up5.png';

import dataStoryTellerCrossgrade from '../../../assets/images/thumbnails/data-storyteller-crossgrade.png';
import dataStoryTeller from '../../../assets/images/thumbnails/datastoryteller.png';
import flickerFreeCrossgrade from '../../../assets/images/thumbnails/flicker-free-crossgrade.png';
import flickerFreeUpgrade from '../../../assets/images/thumbnails/flicker-free-upgrade.jpg';
import flickerFree from '../../../assets/images/thumbnails/flicker-free.png';
import flickerFree3 from '../../../assets/images/thumbnails/flicker-free3.png';
import flickerFree1to3upgrade from '../../../assets/images/thumbnails/FF3-1to3upgrade.png';
import flickerFree2to3upgrade from '../../../assets/images/thumbnails/FF3-2to3upgrade.png';
import placeholder from '../../../assets/images/thumbnails/placeholder.png';
import powerSearch from '../../../assets/images/thumbnails/powersearch.jpg';
import samuraiSharpenCrossgrade from '../../../assets/images/thumbnails/samurai-sharpen-crossgrade.png';
import samuraiSharpen from '../../../assets/images/thumbnails/samurai-sharpen.png';
import lightWrapCrossgrade from '../../../assets/images/thumbnails/the-light-wrap-crossgrade.png';
import lightWrap from '../../../assets/images/thumbnails/the-light-wrap.png';
import transcriptiveUpgrade from '../../../assets/images/thumbnails/transcriptive-upgrade.png';
import transcriptive from '../../../assets/images/thumbnails/transcriptive.png';

const productThumbnails = new Map<ProductId | string, string>([
  ['cloud-all-access', anarchyCloudAllAccess],
  ['cloud-one-app', anarchyCloudOneApp],
  ['cloud-complete-bundle-all-plugins', anarchyCompleteBundleAllPlugins],
  ['eff-it', effIt],
  ['beauty-box-6', beautyBox6],
  ['beauty-box-6-upgrade-1to4', beautyBoxUpgrade1to4],
  ['beauty-box-6-upgrade-5to6', beautyBoxUpgrade5to6],
  ['beauty-box', beautyBox],
  ['beauty-extreme', beautyExtreme],
  ['beauty-flicker', beautyFlicker],
  ['beauty-box-photo', beautyBoxPhoto],
  ['beauty-box-upgrade', beautyBoxUpgrade],
  ['beauty-box-upgrade-123', beautyBoxUpgrade123],
  ['beauty-box-photo-upgrade', beautyBoxPhotoUpgrade],
  ['beauty-box-crossgrade', beautyBoxCrossgrade],
  ['data-storyteller', dataStoryTeller],
  ['data-storyteller-crossgrade', dataStoryTellerCrossgrade],
  ['flicker-free', flickerFree],
  ['flicker-free-3', flickerFree3],
  ['flicker-free-upgrade-1to3', flickerFree1to3upgrade],
  ['flicker-free-upgrade-2to3', flickerFree2to3upgrade],
  ['flicker-free-upgrade', flickerFreeUpgrade],
  ['flicker-free-crossgrade', flickerFreeCrossgrade],
  ['lightwrap', lightWrap],
  ['lightwrap-crossgrade', lightWrapCrossgrade],
  ['powersearch', powerSearch],
  ['samurai-sharpen', samuraiSharpen],
  ['samurai-sharpen-crossgrade', samuraiSharpenCrossgrade],
  ['transcriptive', transcriptive],
  ['transcriptive-upgrade', transcriptiveUpgrade],
  ['placeholder', placeholder],
]);

export default productThumbnails;
